import { DBaseStateSetSub } from "./d-base-state-set-sub";

export interface DBaseStateSetTicker extends DBaseStateSetSub {}
